<template>
  <div class="uc-my-recmd bShadow-5">
    <el-tabs value="tj" class="ui-tabs ui-custom-s">
      <el-tab-pane name="tj">
        <span slot="label" class="lb-txt"> 我的申报 </span>
        <div class="shenbao">
          <div class="item_h">
            <div class="iteminfo">
              <div class="left_lable">申报状态:</div>
              <el-select
                v-model="sbcode"
                placeholder="请选择"
                size="small"
                clearable
              >
              <el-option label="已请求" value="1"></el-option>
                <el-option label="成功" value="2"></el-option>
                <el-option label="失败" value="3"></el-option>
              </el-select>
            </div>
            <div class="iteminfo">
              <div class="left_lable">扣款状态:</div>
              <el-select
                v-model="kkcode"
                placeholder="请选择"
                size="small"
                clearable
              >
                <el-option label="已请求" value="1"></el-option>
                <el-option label="成功" value="2"></el-option>
                <el-option label="失败" value="3"></el-option>
              </el-select>
            </div>
            <div class="iteminfo">
              <div class="left_lable">申报季度:</div>
              <el-date-picker
                clearable
                value-format="yyyy-MM"
                v-model="sbjd"
                type="month"
                placeholder="选择月"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="shenbao_btn">
            <el-popover placement="right" width="400" trigger="click">
              <div>
                <div class="qrclass"><div id="qrcode"></div></div>
              </div>
              <el-button
                style="background: #53acf3; color: white"
                slot="reference"
                @click="toBuy"
                >购买</el-button
              >
            </el-popover>

            <el-button style="background: #53acf3; color: white" @click="init"
              >查询</el-button
            >
          </div>
          <div class="tixing">请确认你的申报结果,点击缴款进行缴税</div>
          <div class="t_list">
            <el-table :data="sblist" border style="width: 100%">
              <el-table-column type="index" width="50" fixed> </el-table-column>
              <el-table-column
                label="申报状态"
                width="80"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.sbcode == 1">已请求</div>
                  <div v-if="scope.row.sbcode == 2">成功</div>
                  <div v-if="scope.row.sbcode == 3">失败</div>
                </template>
              </el-table-column>

               <el-table-column
                label="处理状态"
                width="80"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.jlzt == 1">处理结束</div>
                  <div v-if="scope.row.jlzt == 0">处理中</div>
                </template>
              </el-table-column>
              <el-table-column label="扣款状态" width="80">
                <template slot-scope="scope">
                  <div v-if="scope.row.kkcode == 1">已请求</div>
                  <div v-if="scope.row.kkcode == 2">成功</div>
                  <div v-if="scope.row.kkcode == 3">失败</div>
                  <div v-if="scope.row.kkcode == 4">不代扣</div>
                </template>
              </el-table-column>
              <el-table-column prop="sbjd" label="申报季度" width="80">
              </el-table-column>
              <el-table-column prop="sbje" label="申报金额" width="80">
              </el-table-column>
              <el-table-column prop="shxydm" label="税号" width="180"   show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="快速链接" fixed="right">
                <template slot-scope="scope">
                  <div class="right_bb">
                      <el-button
                      type="text"
                      size="small"

                      @click="toPay(scope.row,2)"
                    >
                      重新申报
                    </el-button>
                    <el-button
                      type="text"
                      size="small"
                      v-if="scope.row.kkcode == 2&&scope.row.jlzt==1"
                      @click="toPay(scope.row,1)"
                    >
                      缴款
                    </el-button>
                    <el-button
                      type="text"
                      size="small"
                      style="width: 50%; overflow: hidden"
                      @click="download(scope.row.file1)"
                      v-if="scope.row.file1"
                    >
                      增值税及附加税费申报表（小规模纳税人适用）</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="download(scope.row.file1)"
                      v-if="scope.row.file2"
                    >
                      定期定额户自行申报
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="fenye">
              <el-pagination
                background
                layout="total, pager"
                :total="total"
                @current-change="pagechange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <!-- <div v-show="showNonePage" class="none-pager">
          <img src="@/assets/image/order_none.png" alt="" />
          <p>暂无申报信息</p>
        </div> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import API from '@/api/api'
import QRCode from 'qrcodejs2'
import store from 'store'
import { mapGetters } from 'vuex'
import { USR_TOKEN } from '@/util/const'
export default {
  name: 'recommend',
  props: {},
  data() {
    return {
      haveQr: false,
      nsrsbh: '',
      ph: '',
      kkcode: '',
      sbcode: '',
      sbjd: '',
      referral: {},
      showNonePage: true,
      sblist: [],
      currentPage: '1',
      total: 0,
    }
  },
  computed: {},
  created() {
    //
  },
  activated() {
    if (!this.userInfo.taxpayerNumber) {
      this.$alert('您还未绑定社会信用代码，请先完善信息', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showClose: false,
      }).then(() => {
        this.$router.push({
          name: 'userInfo',
        })
      })
      return
    }
    if (!this.userInfo.taxControlPanelNumber) {
      this.$alert('您还未绑定税控盘号，请先完善信息', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showClose: false,
      }).then(() => {
        this.$router.push({
          name: 'userInfo',
        })
      })
      return
    }
    this.init()
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {},
  methods: {
    toPay(val,index) {
      this.$router.push({
        name: 'robotLogin',
        query: { type: index, nsrsbh: val.shxydm,op:'yjsb',ph:this.userInfo.taxControlPanelNumber },
      })
    },
    async init() {
      console.log(this.userInfo)
      this.sblist = []
      let request = {
       // shxydm: '92510104MA6CNKUP4D', // '92510104MA6CNKUP4D',
        shxydm: this.userInfo.taxpayerNumber, // '92510104MA6CNKUP4D',
        sbjd: this.sbjd || '',
        sbcode: this.sbcode || '',
        kkcode: this.kkcode || '',
        currentPage: this.currentPage,
        pageSize: '10',
        isJson: true,
      }
      const res = await API.cxsbjl(request)
      if (res.data.statusCode == 200) {
        this.sblist = [...res.data.result.list]
        this.total = parseInt(res.data.result.total)
      }
    },
    pagechange(val) {
      console.log(val)
      this.currentPage = val
      this.init()
    },
    download(val, title) {
      console.log(val)

      let url = val
      const a = document.createElement('a')
      a.href = url
      a.download = title // 下载后文件名
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click() // 点击下载
      document.body.removeChild(a) // 下载完成移除元素
    },
    toBuy() {
      if (this.haveQr == true) {
        return
      }
      let token = store.get(USR_TOKEN)
      let nsrsbh = this.userInfo.taxpayerNumber
      let skph = this.userInfo.taxControlPanelNumber
      let id = this.userInfo.id
      //http://192.168.3.19:8080
      //https://www.chinaqjwx.cn/qf_moblie/#/ckzs
      let op = 'yjsb'
      this.haveQr = true
      //let text = 'https://www.chinaqjwx.cn/qf_moblie/#/ckzs?op='
      let text =
        'https://www.chinaqjwx.cn/qf_moblie/#/ckzs?op=' +
        op +
        '&nsrsbh=' +
        nsrsbh +
        '&skph=' +
        skph +
        '&id=' +
        id +
        '&token=' +
        token
      let qrcode = new QRCode('qrcode', {
        width: 300, // 设置宽度，单位像素
        height: 300, // 设置高度，单位像素
        text: text, // 设置二维码内容或跳转地址
      })
    },
  },
  components: {},
}
</script>

<style lang="stylus" scoped>
.fenye {
  margin-top: 10px;
}

.right_bb {
  display: flex;
}

/deep/ .el-tabs__nav-scroll {
  background-color: #ffffff;
}

.shenbao {
  width: 94%;
  margin: auto;
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 8px;
}

.none-pager {
  text-align: center;
  padding-top: 60px;
}

.uc-my-recmd {
  height: 666px;
  box-sizing: border-box;
  background-color: #F2F4F8;
  overflow: hidden;
}

.iteminfo {
  display: flex;
  align-items: center;
}

.item_h {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.left_lable {
  width: 80px;
  text-align: right;
  margin-right: 10px;
}

.shenbao_btn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.tixing {
  color: red;
  margin-top: 10px;
  margin-bottom: 10px;
}

/deep/ .el-tabs__content {
  height: 530px;
  overflow: auto;
}
</style>
